/** Shared Puck slot helpers for layout/column element blocks. */

export const LAYOUT_CONTENT_SLOT = 'content'

export const LAYOUT_SLOT_MIN_HEIGHT = '128px'

/** One slot per column in patterns like `2`, `2:1`, or `1:2:1`. */
export function getColumnSlotKeys(pattern: string): string[] {
  if (/^\d+$/.test(pattern)) {
    const count = Math.max(parseInt(pattern, 10), 1)
    return Array.from({ length: count }, (_, index) => `col${index + 1}`)
  }

  const segments = pattern.split(':').filter(Boolean)
  return segments.map((_, index) => `col${index + 1}`)
}

export function columnSlotFields(pattern: string): Record<string, { type: 'slot' }> {
  return Object.fromEntries(getColumnSlotKeys(pattern).map(key => [key, { type: 'slot' as const }]))
}

export function columnSlotDefaultProps(pattern: string): Record<string, unknown[]> {
  return Object.fromEntries(getColumnSlotKeys(pattern).map(key => [key, []]))
}

const MAX_GRID_COLUMNS = 6

/** One slot per grid column (2–6 columns). */
export function getGridSlotKeys(columns: number): string[] {
  const count = Math.min(Math.max(Number(columns) || 3, 1), MAX_GRID_COLUMNS)
  return Array.from({ length: count }, (_, index) => `col${index + 1}`)
}

export function gridSlotFields(columns: number): Record<string, { type: 'slot' }> {
  return Object.fromEntries(getGridSlotKeys(columns).map(key => [key, { type: 'slot' as const }]))
}

/** Pre-seed up to MAX_GRID_COLUMNS so changing column count keeps stored slot data. */
export function gridSlotDefaultProps(columns = 3): Record<string, unknown[]> {
  return Object.fromEntries(getGridSlotKeys(columns).map(key => [key, []]))
}

export function gridSlotDefaultPropsMax(): Record<string, unknown[]> {
  return gridSlotDefaultProps(MAX_GRID_COLUMNS)
}
